import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";


const derivarTurnoAOtraSucursal = async ({ params, token, callbacks }) => {
    const response = await connection({ method: 'POST', url: `${ENTITY_URL.DERIVACION.OTRA_SUCURSAL}`, extraHeaders: { token: token }, params: params });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}

export default derivarTurnoAOtraSucursal;